var map = {
	"./microsite-BR.gif": "331a",
	"./microsite-CL.gif": "4470",
	"./microsite-CO.gif": "ec8c",
	"./microsite-ES.gif": "c51b",
	"./microsite-MX.gif": "e631",
	"./microsite-MY.gif": "5e9d",
	"./microsite-PH.gif": "172f",
	"./microsite-PL.gif": "9e64",
	"./microsite-SG.gif": "11cc",
	"./microsite-TH.gif": "79d3",
	"./microsite-TW.gif": "96d9",
	"./microsite-VN.gif": "31fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9488";